import { Controller } from "@hotwired/stimulus"
import { parse, addDays, subDays, format } from "date-fns";

const DATE_FORMAT = 'yyyy-MM-dd';

export default class extends Controller {
  static targets = ["input"];

  advance() {
    if (this.date !== "") {
      this.date = addDays(this.date, 1);
    }

    event.preventDefault();
  }

  rewind() {
    if (this.date !== "") {
      this.date = subDays(this.date, 1);
    }
   
    event.preventDefault();
  }

  preset(event) {
    this.inputTarget.value = event.target.dataset.date;

    event.preventDefault();
  }

  get date() {
    return parse(this.inputTarget.value, DATE_FORMAT, new Date());
  }

  set date(d) {
    this.inputTarget.value = format(d, DATE_FORMAT);
  }
}
